var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3327 3.66663H11.666C9.45688 3.66663 7.66602 5.45749 7.66602 7.66663V24.3333C7.66602 26.5424 9.45688 28.3333 11.666 28.3333H20.3327C22.5418 28.3333 24.3327 26.5424 24.3327 24.3333V7.66663C24.3327 5.45749 22.5418 3.66663 20.3327 3.66663Z",
    stroke: "#FFB85C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 23.6666H17.3327",
    stroke: "#FFB85C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinPhone);
export default __webpack_public_path__ + "static/media/min-phone.12923255a7a10b6ca8deb90cb8a26ca8.svg";
export { ForwardRef as ReactComponent };